var TabHandler = /** @class */ (function () {
    function TabHandler(props) {
        this.tabs = undefined;
        this.panels = undefined;
        this.activePanelId = undefined;
        var tabs = props.tabs, panels = props.panels;
        this.tabs = tabs;
        this.panels = panels;
        this.activePanelId = this.getPanelId(tabs[0]);
        this.init();
    }
    TabHandler.prototype.init = function () {
        var _this = this;
        this.tabs.forEach(function (tab) {
            var panelId = _this.getPanelId(tab);
            var tabId = tab.getAttribute("id");
            //set aria attributes
            var panel = _this.panels.find(function (panel) { return panel.getAttribute("id") == panelId; });
            panel === null || panel === void 0 ? void 0 : panel.setAttribute("role", "tabpanel");
            panel === null || panel === void 0 ? void 0 : panel.setAttribute("aria-labelledby", tabId);
            tab.setAttribute("aria-selected", "".concat(_this.isActive(tab)));
            tab.setAttribute("aria-controls", panelId);
            tab.addEventListener("click", function (event) {
                return _this.onTabClick(event, tab);
            });
            //keyboard navigation
            tab.addEventListener("keydown", function (event) {
                return _this.onTabKeyDown(event, tab);
            });
        });
    };
    TabHandler.prototype.onTabClick = function (event, tab) {
        if (this.isActive(tab)) {
            return;
        }
        this.resetPreviousTabAndPanel();
        this.setActiveTabAndPanel(tab);
    };
    TabHandler.prototype.onTabKeyDown = function (event, tab) {
        var _this = this;
        var tabIndex = this.tabs.findIndex(function (tabItem) { return _this.getPanelId(tabItem) == _this.getPanelId(tab); });
        var previousTab;
        var nextTab;
        if (tabIndex == 0) {
            nextTab = this.tabs[1];
        }
        else if (tabIndex > 0 && tabIndex < this.tabs.length) {
            previousTab = this.tabs[tabIndex - 1];
            nextTab = this.tabs[tabIndex + 1];
        }
        else if (tabIndex == this.tabs.length) {
            previousTab = this.tabs[this.tabs.length - 1];
        }
        if (event.code === "ArrowLeft" && previousTab) {
            this.resetPreviousTabAndPanel();
            this.setActiveTabAndPanel(previousTab);
        }
        if ((event.code === "ArrowRight" || event.code === "ArrowDown") &&
            nextTab) {
            this.resetPreviousTabAndPanel();
            this.setActiveTabAndPanel(nextTab);
        }
    };
    TabHandler.prototype.isActive = function (tab) {
        var panelId = this.getPanelId(tab);
        return panelId == this.activePanelId;
    };
    TabHandler.prototype.getPanelId = function (tab) {
        return tab === null || tab === void 0 ? void 0 : tab.dataset["panel"];
    };
    TabHandler.prototype.getActivePanel = function () {
        var _this = this;
        return this.panels.find(function (panel) {
            return panel.getAttribute("id") == _this.activePanelId;
        });
    };
    TabHandler.prototype.getActiveTab = function () {
        var _this = this;
        return this.tabs.find(function (tab) {
            return _this.isActive(tab);
        });
    };
    TabHandler.prototype.resetPreviousTabAndPanel = function () {
        var tab = this.getActiveTab();
        var panel = this.getActivePanel();
        tab === null || tab === void 0 ? void 0 : tab.setAttribute("aria-selected", "false");
        tab === null || tab === void 0 ? void 0 : tab.setAttribute("tabIndex", "-1");
    };
    TabHandler.prototype.setActiveTabAndPanel = function (tab) {
        var panelId = this.getPanelId(tab);
        var panel = this.panels.find(function (panel) { return panel.getAttribute("id") == panelId; });
        tab === null || tab === void 0 ? void 0 : tab.setAttribute("aria-selected", "true");
        tab.setAttribute("tabIndex", "0");
        tab === null || tab === void 0 ? void 0 : tab.focus();
        this.activePanelId = panelId;
    };
    return TabHandler;
}());
export { TabHandler };
export default TabHandler;
